module.exports = __webpack_public_path__ + "img/doll-relax-zoom.0555f670.png";